import React from "react";
import { RadioButton, RadioGroup } from "@jsq/ds/core";
import { Question } from "../../EntityTypeSurvey/types";
import { buttonGroup } from "./style_vanilla.css";
export type ChoiceSelectorProps = {
  option: Question;
  answers: string[];
  onChange: (question: Question, answer: string) => void;
};
export const ChoiceSelector = ({ option, answers, onChange }: ChoiceSelectorProps) => {
  return (
    <RadioGroup
      name={option.id}
      label={option.question}
      onChange={(e) => onChange(option, e.target.value)}
      className={buttonGroup}
    >
      {answers.map((answer) => (
        <RadioButton
          value={answer}
          id={`${option.id}-${answer}`}
          name={option.id}
          key={answer}
          checked={option.answer === answer}
        >
          {answer}
        </RadioButton>
      ))}
    </RadioGroup>
  );
};
